import styled, { css } from 'styled-components'
import { shouldForwardProp } from 'helpers'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { respondAbove } from 'styles/mediaQueries'
import { fadeInOnRender } from 'styles/animations'

type StyledRadioTileGroupItemProps = {
    isChecked?: boolean
    isDisabled?: boolean
    isError?: boolean
}

export const StyledRadioTileGroupItem = styled(Box).withConfig({
    shouldForwardProp: (prop) =>
        shouldForwardProp<StyledRadioTileGroupItemProps>(
            ['isChecked', 'isDisabled', 'isError'],
            prop
        ),
})<StyledRadioTileGroupItemProps>`
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.grayscale_200};
    padding: 16px;
    border: 2px solid ${({ theme }) => theme.colors.grayscale_200};

    cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};

    ${({ isChecked }) =>
        isChecked &&
        css`
            background-color: ${({ theme }) => theme.colors.grayscale_0};
            border: 2px solid ${({ theme }) => theme.colors.primary_500};
        `}

    @media ${respondAbove.md} {
        padding: ${({ isChecked }) =>
            isChecked ? '16px 24px 24px' : '16px 24px'};
    }
`

export const RadioButtonWrapper = styled.div`
    display: flex;
    pointer-events: none;
`

export const StyledBadge = styled(Box)`
    padding: 2px 9px;
    margin-top: 4px;
    margin-right: 4px;
    float: left;
    border-radius: 2px;
    background-color: ${({ theme }) => theme.colors.secondary_500};
    color: ${({ theme }) => theme.colors.grayscale_0};
    font-size: 8px;
    line-height: 11px;
    text-transform: uppercase;
    white-space: nowrap;
    ${fadeInOnRender};

    @media ${respondAbove.md} {
        margin-right: 8px;
    }
`

export const StyledLabel = styled(Text)`
    display: inline;
    word-wrap: normal;
`
